'use strict';
var classof = require('../internals/classof');

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/to-string.js
// module id = 33
// module chunks = 13